import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { HiOutlineMail, HiOutlineTrash, HiOutlineCalendar, HiOutlineReply, HiOutlineX } from "react-icons/hi";
import "./Contact.css";

const ContactsPanel = () => {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedContact, setSelectedContact] = useState(null); 
  const [replyText, setReplyText] = useState("");

  // Logic to prevent background scroll
  useEffect(() => {
    if (selectedContact) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    // Cleanup on unmount
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [selectedContact]);

  const fetchContacts = async () => {
    try {
      const q = collection(db, "contacts");
      const querySnapshot = await getDocs(q);
      const data = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setContacts(data);
    } catch (error) {
      console.error("Error fetching contacts:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContacts();
  }, []);

  const deleteMessage = async (id) => {
    if (window.confirm("Are you sure you want to delete this message?")) {
      await deleteDoc(doc(db, "contacts", id));
      fetchContacts();
    }
  };

  const handleSendReply = async (e) => {
  e.preventDefault();
  const automaticSubject = "Answering your question";

  try {
    const res = await fetch("http://localhost:5000/send-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        to: selectedContact.email,
        subject: automaticSubject,
        message: replyText
      })
    });

    const data = await res.json();

    if (data.success) {
      alert(`Reply sent to ${selectedContact.name}!`);
      setSelectedContact(null);
      setReplyText("");
    } else {
      alert("Failed to send email.");
    }
  } catch (err) {
    console.error(err);
    alert("Error sending email.");
  }
};

  if (loading) return <div className="panel-loading">Loading Messages...</div>;

  return (
    <div className="contacts-panel">
      <div className="panel-header">
        <h2>📩 User Messages</h2>
        <p>{contacts.length} inquiries received</p>
      </div>

      <div className="contact-cards-grid">
        {contacts.length > 0 ? (
          contacts.map((contact) => (
            <div className="contact-card" key={contact.id}>
              <div className="card-top">
                <span className="subject-badge">{contact.subject || "General Inquiry"}</span>
                <div className="card-actions">
                  <button className="reply-card-btn" title="Reply" onClick={() => setSelectedContact(contact)}>
                    <HiOutlineReply />
                  </button>
                  <button className="delete-card-btn" title="Delete" onClick={() => deleteMessage(contact.id)}>
                    <HiOutlineTrash />
                  </button>
                </div>
              </div>

              <div className="card-body">
                <p className="message-text">"{contact.description}"</p>
              </div>

              <div className="card-footer">
                <div className="sender-info">
                  <div className="avatar-small">
                    {contact.name?.charAt(0).toUpperCase() || "U"}
                  </div>
                  <div>
                    <h4 className="sender-name">{contact.name}</h4>
                    <span className="sender-email"><HiOutlineMail /> {contact.email}</span>
                  </div>
                </div>
                <div className="message-date">
                   <HiOutlineCalendar /> 
                   {contact.timestamp ? (
                     contact.timestamp.toDate ? 
                     contact.timestamp.toDate().toLocaleDateString() : 
                     new Date(contact.timestamp).toLocaleDateString()
                   ) : (
                     new Date().toLocaleDateString()
                   )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="no-messages">No messages available.</div>
        )}
      </div>

      {/* Reply Modal */}
      {selectedContact && (
        <div className="modal-overlay" onClick={() => setSelectedContact(null)}>
          <div className="reply-modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Reply to {selectedContact.name}</h3>
              <button className="close-modal" onClick={() => setSelectedContact(null)}>
                <HiOutlineX />
              </button>
            </div>
            <form onSubmit={handleSendReply}>
              <div className="modal-info">
                <p><strong>To:</strong> {selectedContact.email}</p>
                <p><strong>Subject:</strong> Answering your question</p>
              </div>
              <textarea 
                placeholder="Write your answer here..."
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
                required
                autoFocus
              />
              <div className="modal-actions">
                <button type="button" className="cancel-btn" onClick={() => setSelectedContact(null)}>Cancel</button>
                <button type="submit" className="send-btn">Send Reply</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactsPanel;